const Flickity = require('flickity')

const carousel = (elem) => {
  const options = {
    cellAlign: 'center',
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false
  }

  const flkty = new Flickity(elem, options)
  const next = document.querySelector('.carousel-nav-next')
  const prev = document.querySelector('.carousel-nav-previous')

  next.addEventListener('click', () => {
    flkty.next()
  })
  prev.addEventListener('click', () => {
    flkty.previous()
  })

  const carouselHeight = () => {
    const firstSlide = elem.querySelector('.carousel-element');
    const slideshowNav = document.querySelector('.slideshow-nav');
    if (firstSlide !== null && slideshowNav !== null) {
      const slideHeight = firstSlide.offsetHeight
      slideshowNav.style.top = (slideHeight / 2) + 'px'
    }
  }

  carouselHeight()

  // eslint-disable-next-line no-undef
  window.onresize = _.throttle(() => {
    carouselHeight()
  }, 200)
}

window.addEventListener('load', () => {
  const elems = document.querySelectorAll('.carousel')
  if (elems !== null) {
    elems.forEach((elem) => {
      carousel(elem)
    })
  }
})
